/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Injector, Input, ViewChild } from '@angular/core';
import { ButtonService, SlideWindowAbstract, TimeService } from '@dm/core';
import { ToolService } from 'app/common/services';
import { ShardSwitch } from 'app/config';
import { GuideStorageKey } from 'app/feature/share/smart-assistant/smart-assistant.const';
import { SmartAssistantService } from 'app/feature/share/smart-assistant/smart-assistant.service';

import { TaskComponent } from '../task/task.component';

@Component({
    selector: 'app-task-s',
    templateUrl: './task-s.component.html',
    styleUrls: ['./task-s.component.scss'],
})

export class TaskSComponent extends SlideWindowAbstract implements OnInit {
    @Input() taskId: string;
    @ViewChild('appTask') appTask: TaskComponent;

    ShardSwitch = ShardSwitch;

    windowVisible = false;

    taskCentertitle = this.i18nService.get('common.taskCenter_title');

    constructor(
        public injector: Injector,
        public buttonService: ButtonService,
        public toolService: ToolService,
        protected timeService: TimeService,
        private smartAssistantService: SmartAssistantService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.windowVisible = true;
        // 关闭智能助手，避免页面过窄
        this.smartAssistantService.setGuideConfig(GuideStorageKey.showSmartAssistant, false);
    }

    close(): void {
        if (this.appTask && this.appTask.taskDetailComponent && this.appTask.taskDetailComponent.instance) {
            this.appTask.taskDetailComponent.instance.show = false;
            this.appTask.taskDetailComponent = null;
        }

        super.close();
    }
}
